import { ESignType, EMPTY_SIGNED_TYPE } from './esigntype.model';
import { ESignResponse } from './esign-response.model';

export interface ChecklistSignSaveDto {
  pinNumber: number;
  checkListTypeId: number;
  checklistRoleTypeId: number;
  flightId: number;
  checklistTasks: ChecklistTaskData[] | null;
}

export interface ChecklistTaskData {
  customerId: number;
  tripId: number;
  flightId: number;
  legNumber: number;
  checkListTypeId: number;
  checklistRoleTypeId: number;
  checklistRoleTypeName: string;
  configTaskId: number;
  configTaskName: string;
  configTaskOrder: number;
  selectedByUser: string;
  selectedDateTime: moment.Moment | undefined;
  checklistSignId: number | null;
}

export interface ChecklistSignResponse {
  checklistSignId: number;
  flightId: number;
  checklistTypeId: number;
  checklistRoleTypeId: number;
  signedType: ESignType;
  signResponse: ESignResponse | null;
}

export const EMPTY_CHECKLISTS_SIGN: ChecklistSignResponse = {
  checklistSignId: 0,
  flightId: 0,
  checklistTypeId: 0,
  checklistRoleTypeId: 0,
  signedType: EMPTY_SIGNED_TYPE,
  signResponse: null
};

export enum CheckListType {
  PreFlight = 1,
  PostFlight = 2
}

export enum CheckListsRoleType {
  Scheduling = 1,
  Pilot = 2,
  Maintenance = 3
}

export interface CheckListsRoleTypeSelect {
  key: number;
  value: string;
}

export interface CheckListsAvailable {
  schedulingChecklists: ChecklistTaskData[];
  pilotChecklists: ChecklistTaskData[];
  maitenanceChecklists: ChecklistTaskData[];
  checklistSignResponse: ChecklistSignResponse[];
}

export interface ChecklistForSelect {
  id: number;
  name: string;
}

export interface CheckListsTypeSelect {
  key: number;
  value: string;
}

export interface VoidCorrectDataInProgress {
  isVoid: boolean;
  isCorrect: boolean;
  flightId: number;
  checklistRoleTypeId: number;
  checkListTypeId: number;
  checkListsData: ChecklistTaskData[];
}

export const EMPTY_VOIDCORRECT_INPROGRESS: VoidCorrectDataInProgress = {
  isVoid: false,
  isCorrect: false,
  flightId: 0,
  checklistRoleTypeId: 0,
  checkListTypeId: 0,
  checkListsData: []
};

export class ChecklistSaveSignResponseDto {
  esignResponse: ESignResponse;
  checklistSignId: number;
}
